export function detectMimeType(b64: string): string | any {
  try {
    return b64.match(/:.+;/g)[0].slice(1, -1);
  } catch {
    console.error('Type not found in this file!');
  }
}
